<template>
  <div>
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else style="display: flex; flex-direction: column">
      <abstractTable  
        :data="visitInfo"
        :definitionTable="true"
        :definitionTableWidth="'30%'"
        :classes="'ui compact definition table'"
        v-if="packagesById"
      />
      
      <table class="ui celled center aligned table" v-if="packagesById">
        <thead>
          <tr>
            <th>Packages</th>
            <th class="no-print">Quantity</th>
            <th class="no-print">Actual quantity</th>
            <th class="no-print">Remainder</th>
            <th class="no-print" v-if="isAdmin()">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(visitDetail, index) in visit.visit_details"
            :key="'visit-detail-' + index"
          >
            <td>{{ packagesById[visitDetail.package_id].name }}</td>
            <td class="no-print">{{ visitDetail.quantity || 0 }}</td>
            <td class="no-print">{{ visitDetail.actual_quantity || 0 }}</td>
            <td class="no-print">{{ visitDetail.remainder || 0 }}</td>
            <td class="no-print" v-if="isAdmin()">
              {{ formatPrice(visitDetailPrice(visitDetail)) }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="ui orange button"
        v-if="visit.visit_status_id === VisitStatuses.AFTER_WORK && visitHasRemainders()"
        @click="updateReservation(visit.reservation_id)">
        <!-- <i class="file icon"></i> -->
        Update Reservation Packages
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    visit: { type: Object, required: true },
    packages: { type: Array, required: true },
    patient: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      doctors: null,
      doctor_id: null,
      packagesById: null
    };
  },
  mounted() {
    this.loading = true;
    this.$http.get('doctors/list').then(response => {
      this.doctors = response.data;
      this.packagesById = this.packages.reduce((obj, p) => ({ ...obj, [p.id]: p}), {})
      this.loading = false;
    });
  },
  computed: {
    totalPrice() {
      return window._.sumBy(this.visit.visit_details, visitDetail => {
        return this.visitDetailPrice(visitDetail)
      });
    },
    visitInfo() {
      return {
        doctor: this.$auth.check('doctor') && this.doctorsObject
          ? {
              html: true,
              functionality: () => {
                this.navigateTo('Show_Doctor', {
                  key: 'params',
                  value: { id: this.visit.doctor_id }
                });
              },
              value: `<a style="cursor: pointer;">${this.doctorsObject && this.doctorsObject[this.visit.doctor_id] ? this.doctorsObject[this.visit.doctor_id].user.name : '-'}</a>`
            }
          : this.doctorsObject && this.doctorsObject[this.visit.doctor_id] ? this.doctorsObject[this.visit.doctor_id].user.name : '-',
        patient: this.$auth.check('doctor')
          ? {
              html: true,
              functionality: () => {
                this.navigateTo('Show_Patient', {
                  key: 'params',
                  value: { id: this.patient.id }
                });
              },
              value: `<a style="cursor: pointer;">${this.adjustName(this.patient.name)}</a>`
            }
          : this.adjustName(this.patient.name),
        room: this.visit.room ? this.visit.room.name : '-',
        reserved_time: this.formattedTime(this.visit.time),
        started_at: this.formattedTime(this.visit.started_at),
        finished_at: this.formattedTime(this.visit.finished_at),
        total_price: this.isAdmin() ? this.formatPrice(this.totalPrice) : '-',
        note: this.visit.note
      };
    },
    doctorsObject() {
      return this.doctors ? window._.keyBy(this.doctors, 'id') : null;
    }
  },
  methods: {
    visitHasRemainders () {
      return this.visit.visit_details.filter(vd => Number(vd.remainder) < 0).length
    },
    visitDetailPrice(visitDetail) {
      return Number(visitDetail.quantity) * Number(this.packagesById[visitDetail.package_id].unit_price)
    },
    formattedTime(time) {
      if (time) {
        return window.moment(time).format('DD/MM/YYYY hh:mm a');
      }
      return '-';
    },
    updateReservation(reservationId){
      this.navigateTo('Update_Reservation', {
        key: 'params',
        value: {
          id: reservationId
        }
      })
    }
  }
};
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/VisitInfo.vue